<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">FAQ Section Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editFAQSection">Edit Section</button>
                </div>
            </div>
            <div class="table-responsive" v-if="faqsection">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{faqsection.faqHeaderId}}</td>
                    </tr>
                    <tr>
                        <th>Section Header</th>
                        <td>{{faqsection.faqHeader}}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="faqsection.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'Viewfaqsection',
        components: {
            LTable,
        },
        created (){
            console.log('inside view greeting')
        this.$store.dispatch('GETSELECTEDFAQSECTION', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedFaqsection)
            this.faqsection = this.selectedFaqsection;
        })
    },
    data () {
        return {
          faqsection: {}
        }
    },
    methods: {
        editFAQSection(){
            this.$router.push({ name: 'EditFAQSection', params: { id: this.faqsection.faqHeaderId}})
        },
    },
    computed: {...mapGetters([
        'selectedFaqsection'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FAQSect/FAQSectionDetails.vue